import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses } from '../data/content';
import { CTAButton } from './CTAButton';
export function Bonuses() {
  return <section className="w-full bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-62" data-mp="plsjs38jiy8p">
      <div className="mx-auto max-w-4xl" data-id="element-63" data-mp="autfh4eqmvux">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-gold-400 sm:text-4xl" data-id="element-64" data-mp="ftwm2tad9a50">
          Exclusive bonuses
        </h2>
        <p className="mt-1 text-center font-display text-lg font-600 uppercase tracking-[0.2em] text-white" data-id="element-65" data-mp="1t3ou0sok0y7">
          Included free today
        </p>
        <p className="mx-auto mt-4 max-w-xl text-center text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-66" data-mp="3o2502g6e2o16">
          Designed to make your DVO assessment process faster, more organized, and easier to apply.
        </p>

        <div className="mt-9 space-y-8" data-id="element-67" data-mp="1mbjr531xkfvx">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-2xl border border-white/10 bg-navy-900" data-id="element-68" data-mp="1r9l89ifsq54r">
              <div className="bg-navy-800 px-4 pb-0 pt-4 sm:px-6" data-id="element-69" data-mp="3ic3he3epkqcp">
                <p className="font-display text-sm font-700 uppercase tracking-[0.2em] text-gold-500" data-id="element-70" data-mp="3detvgxqj2wtm">
                  {bonus.label}
                </p>
                <h3 className="mt-1 font-display text-2xl font-700 uppercase leading-tight text-white sm:text-3xl" data-id="element-71" data-mp="3n5etaiydnxbh">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-base font-600 text-gold-400" data-id="element-72" data-mp="2zhoj6g0811px">{bonus.subtitle}</p>
              </div>

              <img src={bonus.image} alt={`${bonus.title} — ${bonus.subtitle}`} className="block w-full bg-white" width={1280} height={1280} loading="lazy" data-id="element-73" data-mp="2uiu15ga2vh6v" />

              <div className="p-5 sm:p-6" data-id="element-74" data-mp="nogh1anj5lv3">
                <p className="text-sm leading-relaxed text-slate-300" data-id="element-75" data-mp="ir6uc2rizoay">{bonus.description}</p>

                <p className="mt-5 text-[11px] font-700 uppercase tracking-[0.18em] text-slate-400" data-id="element-76" data-mp="3ciwqsol3rhim">
                  {bonus.includesLabel}
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-77" data-mp="3hgg7rw96q8e9">
                  {bonus.includes.map(item => <li key={item} className="flex items-start gap-2" data-id="element-78" data-mp="3lhi3w47t24c0">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-500" aria-hidden="true" data-id="element-79" data-mp="3qhe8a4kezxs3" />
                      <span className="text-sm leading-snug text-slate-200" data-id="element-80" data-mp="2xt8r1rskkqx0">{item}</span>
                    </li>)}
                </ul>

                <p className="mt-5 text-sm font-600 text-white" data-id="element-81" data-mp="32r0jqo11gh29">→ {bonus.outcome}</p>

                <div className="mt-5 flex items-center gap-3" data-id="element-82" data-mp="37l4p52unoh18">
                  <span className="text-sm font-600 text-slate-400 line-through" data-id="element-83" data-mp="2a3ee7a8932cr">
                    Value {bonus.value}
                  </span>
                  <span className="rounded-full bg-gold-500 px-3 py-1 font-display text-sm font-700 uppercase tracking-wide text-navy-950" data-id="element-84" data-mp="2f1fytzlbr9qc">
                    Free
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <p className="mt-10 text-center font-display text-2xl font-700 uppercase leading-tight text-gold-400 sm:text-3xl" data-id="element-85" data-mp="1xk8znefb966k">
          Get all 5 bonuses without paying anything extra
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-86" data-mp="1omqb402gk9px">
          <CTAButton label="Get DVO Master Protocol™ now" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-87" data-mp="1jup34qcbp55p" />
        </div>
      </div>
    </section>;
}